import * as React from 'react';

const ChevronUp16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M2.97 10.558a.75.75 0 0 0 1.06 0l4.47-4.47 4.47 4.47a.75.75 0 1 0 1.06-1.061l-5-5a.75.75 0 0 0-1.06 0l-5 5a.75.75 0 0 0 0 1.06Z"
  }
));
ChevronUp16.Size = 16;
ChevronUp16.Title = "ChevronUp";

export { ChevronUp16 as default };
